export const CustomerDashboard = () => {
  return <div className="text-xl font-semibold">CustomerDashboard Dashboard</div>;
};
